import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import { CustomInputField } from '../custom-text-field';

interface SliderInputProps {
  marks:{ value:number, label:string }[]
  defaultValue:number,
  step:number,
  min:number,
  max:number,
  onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
  onChange: (value: number | number[]) => void;
  value: number | undefined;
  name: string | undefined;
  label: string | React.ReactNode | undefined;
  placeholder?: string;
  tabIndex?: number;
}
const CustomSlider = styled(Slider)(({ theme }) => ({
  color: '#E5E5E5',
  height: 5,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: theme.palette.background.paper,
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: theme.palette.primary.main,
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    padding: 0,
    width: 32,
    height: 32,
    backgroundColor: 'black',
    color: 'white',
  },
}));

const SliderInput = React.forwardRef(({
  marks, defaultValue, step, min, max, onChange, onBlur, value, name, label, placeholder, tabIndex,
}:SliderInputProps, ref) => {
  const onChangeInput = (inputValue:string) => {
    if (inputValue) {
      onChange(parseInt(inputValue, 10));
    } else {
      onChange(0);
    }
  };
  return (
    <Box>
      <Typography variant="body1">{label}</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={10}>
          <CustomSlider
            aria-label="slider"
            defaultValue={defaultValue}
            step={step}
            min={min}
            max={max}
            value={value}
            onChange={(e, v, __) => onChange(v)}
            valueLabelDisplay="auto"
            marks={marks}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <CustomInputField
            onBlur={onBlur}
            value={value}
            name={name}
            ref={ref}
            onChange={(e:any) => onChangeInput(e.target.value)}
            placeholder={placeholder}
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
});
SliderInput.defaultProps = {
  placeholder: '',
  tabIndex: 0,
};

export default SliderInput;
